import { GaEventData } from "../../types/EventsData";
import { AnalyticsTracker } from "../AnalyticsTracker";
import { ExecutionContext } from "../../types/ExecutionContext";

export class CompositeGoogleAnalyticsTracker extends AnalyticsTracker<GaEventData> {
	constructor(private readonly trackers: AnalyticsTracker<GaEventData>[]) {
		super();
	}

	override set executionContext(context: ExecutionContext) {
		for (const tracker of this.trackers) {
			tracker.executionContext = context;
		}
	}

	submitPageView(): void {
		for (const tracker of this.trackers) {
			tracker.submitPageView();
		}
	}

	submitEvent(eventData: GaEventData): void {
		for (const tracker of this.trackers) {
			tracker.submitEvent(eventData);
		}
	}
}
